import React, { useState } from "react";
import { useRouter } from 'next/router'
import { Modal, Button } from 'react-bootstrap';

import InputMask from "react-input-mask";

import { JobAPI } from "../lib/conduit"
import ToastManager from "../lib/toastManager"
import UserManager from "../lib/userManager"
import { cleanNumber, isNumeric } from "../lib/inputUtils"


export default function ApplyModal({job, showApply, onShowApplyUpdate, employer, btnColor, btnTextColor}) {
  const [phone, setPhone] = useState("");
  const router = useRouter();

  const handleClose = () => onShowApplyUpdate(false);
  const handleShow = () => onShowApplyUpdate(true);
  const handlePhone = (e)  => setPhone(e.target.value)

  const handleApply = async (e) => {
    e.preventDefault();

    const authToken = UserManager.getAuthToken();
    const identifier = job.identifier;
    const phoneNumber = cleanNumber(phone)
    
    if(!isNumeric(phoneNumber)) return;

    const res = await JobAPI.apply(authToken, identifier, phoneNumber)

    if(res.success) {
      if(!res.action) {
        handleClose();
        ToastManager.successfullJobApply();
      } else if(res.action === "Show Form"){
        router.push("/jobs/" + job.identifier + "/apply")
      }
    } else {
      handleClose();
      ToastManager.errorToast(res.errors[0])
    }
  }

  return (
    <Modal show={showApply} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title style={{fontWeight: "bold", textAlign: "center", width: "100%"}}>Apply to the Job</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{border: "none"}}>
        <p className="form-label" style={{fontWeight: "bold", marginBottom: 5}}>Phone number</p>
        <form onSubmit={(e) => handleApply(e)}>
          <InputMask className="form-control" placeholder="Enter your phone number" style={{marginBottom: 10}} mask="(999) 999-9999" onChange={handlePhone} required></InputMask>
          <Button variant="primary" className="btn-block" type="submit" style={{background: (btnColor ? btnColor : ""), borderColor: (btnColor ? btnColor: ""), color: (btnTextColor ? btnTextColor : "")}}>
            Continue
          </Button>
        </form>
        <p className="form-label" style={{opacity: 0.5, textAlign: "center", marginTop: 15}}>We need your phone number so we can share your contact info with {job.employer}!</p>
      </Modal.Body>
    </Modal>
  );
}